import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import useIncrementingTimer from '../../../hooks/useIncrementingTimer';
import { contactRoutes } from '../../../routes';
import { SerializedTwilioCall, friendlyCallStatus } from '../../../utils/twilioHelpers';

interface Props {
    twilioCall: SerializedTwilioCall | undefined;
    callStartTime: string | undefined;
}

export default function ActiveCallContact({ twilioCall, callStartTime }: Props) {
    const { classes } = useStyles();
    const history = useHistory();

    const timer = useIncrementingTimer(callStartTime);

    const handleNavigate = () => {
        if (twilioCall?.parameters.contactId) {
            history.push(contactRoutes.setDetails(twilioCall.parameters.contactId));
        }
    };

    return (
        <ButtonBase onClick={handleNavigate} className={classes.button}>
            <Grid container direction="column" wrap="nowrap">
                <Grid item xs="auto">
                    <Typography variant="body1">
                        {twilioCall?.parameters.contactName || 'Unknown Caller'}
                    </Typography>
                </Grid>
                <Grid item xs="auto">
                    {twilioCall?.status === 'pending' && (
                        <Typography variant="caption">Incoming Call</Typography>
                    )}
                    {twilioCall?.status !== 'pending' && (
                        <>
                            <Typography variant="caption">{`${friendlyCallStatus(
                                twilioCall?.status,
                            )} - `}</Typography>
                            <Typography variant="caption">
                                {`${timer.minutes}:${timer.seconds.toString().padStart(2, '0')}`}
                            </Typography>
                        </>
                    )}
                </Grid>
            </Grid>
        </ButtonBase>
    );
}

const useStyles = makeStyles()({
    button: {
        textAlign: 'left',
    },
});
